import { useGetAvailableSpaPackages } from '@features/spa/hooks';

type UseSpaPackageDateAvailabilityParams = {
  propertyId: number;
  packageId: number;
  date: string;
  guests?: number;
  language: string;
  enabled: boolean;
};

export function useSpaPackageDateAvailability({
  propertyId,
  packageId,
  date,
  guests,
  language,
  enabled,
}: UseSpaPackageDateAvailabilityParams) {
  const { data, isFetching } = useGetAvailableSpaPackages(
    propertyId,
    { category: null, date, guests },
    language,
    enabled
  );

  const availablePackages = Array.isArray(data) ? data : [];
  const isUnavailableForDate =
    enabled &&
    !isFetching &&
    data !== undefined &&
    !availablePackages.some((availablePackage) => availablePackage.id === packageId);

  return { isUnavailableForDate, isCheckingAvailability: enabled && isFetching };
}
